import { RadarIcon } from './RadarIcon';

/**
 * author: Google
 * id 73BD6C2A-0D5B-4DF6-9FA3-EC489AFBF947
 * name radar
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/radar.svg
 * tags
 */
export const TrackChangesIcon = RadarIcon;
export default TrackChangesIcon